import { render, staticRenderFns } from "./quesSuccess123.vue?vue&type=template&id=2b68aee6"
import script from "./quesSuccess123.vue?vue&type=script&lang=js"
export * from "./quesSuccess123.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess123.vue?vue&type=style&index=0&id=2b68aee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports